import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { ACTIONS as CHAT_ACTIONS } from "../../../redux/chat";
import ChatPageSwitch from "./page-switch";

import SyledChatPage from "./styles";

const ChatPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const params = useParams();
  const { currentChat, api, init } = useSelector((state) => state.chat);
  const { messages, newChat, hasAccepted, info, firstMessage, isChatRequest } =
    currentChat;

  const cleanUpCachedLocalStorage = () => {
    // localStorage.removeItem("ts ");
    // navigate("/chat");
  };

  useEffect(() => {
    if (init) {
      dispatch(CHAT_ACTIONS.getChatMessages({ chatId: params.chatId }));
    }
  }, [params.chatId, init]);

  // useEffect(() => {
  //   console.log({
  //     success: api.success,
  //     currentChat,
  //     newChat,
  //     isChatRequest,
  //     CONDITION:
  //       api.success &&
  //       !currentChat?.messages?.content &&
  //       !newChat &&
  //       !isChatRequest,
  //   });

  //   if (
  //     api.success &&
  //     !currentChat?.messages?.content &&
  //     !newChat &&
  //     !isChatRequest
  //   ) {
  //     cleanUpCachedLocalStorage();
  //   }
  // }, [api, currentChat, newChat, isChatRequest]);

  return (
    <SyledChatPage>
      <div className="chat-page">
        <ChatPageSwitch
          loading={api.loading || !init}
          newChat={newChat}
          hasAccepted={hasAccepted}
          isChatRequest={isChatRequest}
          messages={messages}
          name={info.name}
          surname={info.surname}
          profilePicture={info.profilePicture}
          firstMessage={firstMessage}
        />
      </div>
    </SyledChatPage>
  );
};

export default ChatPage;
